// extracted by mini-css-extract-plugin
export var discard = "_3x-3";
export var muiTooltipTooltip = "_3x-5";
export var notificationBar = "_3x-2";
export var saveButtonHoverSlotWrapper = "_3x-4";
export var show = "_3x-1";
export var spacer = "_3x-0";